export default {
  namespaced: true,

  state: {
    id: null,
    name: '',
    categoryName: '',
    categoryId: null,
    vendorTabIndex: 0
  },

  mutations: {
    setId (state, id) {
      state.id = id
    },
    setName (state, name) {
      state.name = name
    },
    setCategoryName (state, categoryName) {
      state.categoryName = categoryName
    },
    setCategoryId (state, categoryId) {
      state.categoryId = categoryId
    },
    setVendorTabIndex (state, value) {
      state.vendorTabIndex = value
    }
  }
}
